import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'hd-side-menu-item',
  standalone: true,
  imports: [NgClass, NgStyle, TranslateModule],
  templateUrl: './side-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuItemComponent {
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) labelKey!: string;
  @Input() primaryTextColor?: boolean;
}
